import React, { useEffect, useState } from 'react';
import { FaTabletAlt } from 'react-icons/fa';
import * as Motion from 'motion/react';
import DashboardList, { DashboardDeviceListRenderComponent } from '../../components/DashboardList';
import Loader from '../../components/Loaders';
import useSocket from '../../hooks/useSocket';
import { getDevices } from '../../api/v1/devices';
import { animationStaggeredItem } from '../../animations';
import '../../styles/screen.scss';

const { motion } = Motion;


const Devices = () => {
  const [devices, setDevices] = useState([]);
  const [connectedIds, setConnectedIds] = useState(new Set());
  const [isLoading, setIsLoading] = useState(true);
  const { isConnected, send, subscribe } = useSocket();

  const loadDeviceList = async () => {
    const result = await getDevices();
    setDevices(result?.data);
  };

  const devicesWithConnection = devices?.map(device => ({
    ...device,
    isConnected: connectedIds.has(device.deviceId)
  }));

  useEffect(() => {
    if (devices && isConnected) {
      const unsubscribe = subscribe('devicesResponse', (message) => {
        setConnectedIds(new Set(message.payload.map(d => d.deviceId)));
      });

      send(JSON.stringify({ channel: 'devicesRequest' }));

      return unsubscribe;
    }
  }, [devices, isConnected]);

  useEffect(() => {
    (async () => {
      await loadDeviceList();
      setIsLoading(false);
    })();
  }, []);


  return (
    <>
      <Motion.AnimatePresence>
        {isLoading && <Loader/>}
      </Motion.AnimatePresence>

      <motion.div variants={animationStaggeredItem} className="screen-header">
        <div className="screen-title-wrapper">
          <h2 className="screen-title">
            <FaTabletAlt />
            Devices
          </h2>
        </div>
      </motion.div>

      <DashboardList items={devicesWithConnection} RenderComponent={DashboardDeviceListRenderComponent}/>
    </>
  )
};

export default Devices;
